import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { GenericService } from "@services";
import utils from "@utils";

class StateSelection extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			USStates: [],
			loading: false,
		};
	}

	componentDidMount = () => this.getUSStates();

	getUSStates() {
		const { lang } = global;
		const state = { ...this.state };

		this.setState({ loading: true });

		GenericService.getUSStates()
			.then(({ data }) => {
				state.USStates = data.map(USState => ({
					value: USState.Id,
					label: `${USState.Abbreviation} - ${USState.Name}`,
				}));

				state.loading = false;

				this.setState(state);
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading US States"),
					title: "Oops",
				});
				this.setState({ loading: false });
			});
	}

	render() {
		const { lang } = global;
		const { value, name, className, id, onChange, onBlur, placeholder, disabled, dataTestId } =
			this.props;
		const { USStates, loading } = this.state;

		return (
			<select
				className={`state-select ${className || ""}`}
				id={id}
				value={value || ""}
				name={name}
				disabled={disabled}
				placeholder={lang.t(placeholder)}
				onBlur={onBlur}
				onChange={onChange}
				data-test-id={dataTestId}
			>
				<option value="">{lang.t(placeholder)}</option>
				{!loading &&
					USStates.map(({ value: stateId, label }) => (
						<option
							key={`stateSelect${stateId}`}
							value={stateId}
						>
							{label}
						</option>
					))}
			</select>
		);
	}
}

StateSelection.propTypes = {
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	className: PropTypes.string,
	id: PropTypes.string,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func,
	placeholder: PropTypes.string,
	disabled: PropTypes.bool,
	dataTestId: PropTypes.string,
};

StateSelection.defaultProps = {
	value: "",
	className: undefined,
	id: undefined,
	disabled: false,
	onBlur: () => undefined,
	placeholder: "Select State",
	dataTestId: "",
};

export default StateSelection;
